import { postAction } from './request'

/**
 * 获取优惠券数据
 * @param {*} params
 * @returns
 */
export async function getCouponData(params = {}) {
  return postAction('/gw/coupon/query', params)
}


/**
 * 服务通知
 * @returns
 */
export async function getMessageNotify(params = {}) {
  return postAction('/cms/message-box/message/notify',params)
}

/**
 * 服务通知列表
 * @returns
 */
export async function getMessageNotifyList(params = {}) {
  return postAction('/cms/message-box/message/notify/list',params)
}

/**
 * 清除流消息未读数
 * @param {*} params
 * @returns
 */
export async function clearDeliveryMessageUnread() {
  return postAction('/cms/message-box/trade-delivery/clear')
}

/**
 * 获取物流消息列表
 * @param {*} params
 * @returns
 */
export async function getDeliveryMessageList(params = {}) {
  return postAction('/cms/message-box/trade-delivery/infos', params)
}

/**
 * 获取物流消息未读数
 * @param {*} params
 * @returns
 */
export async function getDeliveryMessageUnread() {
  return postAction('/cms/message-box/trade-delivery/unread')
}

/**
 * 将未读消息全部置为已读
 * @returns
 */
export async function postClearNotifyUnread(params = {}) {
  return postAction('/cms/message-box/unread/notify/clear', params)
}


/**
 * 将marketing未读消息全部置为已读
 * @returns
 */
export async function marketingClearUnread(params = {}) {
  return postAction('/cms/message-box/unread/marketing/clear', params)
}


/**
 * 获取marketing消息列表
 * @param {*} params
 * @returns
 */
export async function getMarketingMessageList(params = {}) {
  return postAction('/cms/message-box/marketing/list', params)
}
